import { useEffect, useState } from "react";
import { _BudgetSheetFactory, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { BasicTable } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import { Modal } from "../../theme/Component/Modal";
import { SelectBudgetID } from "../../admin/configuracion/BudgetID/SelectBudgetID";
import { MASK_MONEY } from "../../theme/Component/BasicTable2";
import { InputMoney } from "../../theme/Input/InputMoney";
import { SelectBudgetResourceForYear } from "../../admin/configuracion/BudgetResource/BudgetResourceForYear";
import { SelectBudgetSourceForYear } from "../../admin/configuracion/BudgetSource/SelectBudgetSourceForYear";

interface Props {
    formData: any;
    onChange: Function;
}

export const BudgetReductionFactoryValue = ({ formData, onChange }: Props) => {

    const { bean, setBean, lista, setLista, instance } = useDataBean(_BudgetSheetFactory);
    const [initBean, setInitBean] = useState<any>({});
    const [missingFields, setMissingFields] = useState<string[]>([]);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    const head = [
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Tipo de Presupuesto', property: 'BudgetTypeName', visible: true },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente de Financiamiento', property: 'BudgetSourceName', visible: true },
        { title: 'Vr Restante', property: 'LeftValue', visible: true },
        { title: 'Valor Presupuesto', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    const listaBotones = () => {
        const botones = [
            // { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { eliminarItem() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const createItem = () => {
        setBean({});
        setModal({ ...modal, "view": true, "name": "Crear" })
    }

    const eliminarItem = () => {
        const updatedLista = lista.filter((item: any) =>
            JSON.stringify(item.DataBeanProperties) !== JSON.stringify(bean)
        );

        setBean({});
        setLista(updatedLista);
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: createItem }
    ]

    const createNewItem = () => {

        const updatedLista = lista.filter((item: any) =>
            JSON.stringify(item.DataBeanProperties) !== JSON.stringify(initBean)
        );

        console.log(formData.FormDate + " " + formData.IDBudgetType + " " + bean.BudgetIDStr + " " + bean.IDBudgetSource + " " + bean.IDBudgetResource + " " + bean.Value + " " + bean.Description)

        instance.createBudgetRowForReductionToInitialBudget(formData.FormDate, formData.IDBudgetType, bean.IDBudgetResource, bean.IDBudgetSource, bean.BudgetIDStr, bean.Value, bean.Description).then(
            (resp) => {
                let temp = [...updatedLista, {
                    DataBeanProperties: resp,
                    DataBeanName: 'budget.Budget'
                }];
                setLista(temp);
                setBean({});
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const setRowBean = (object: any) => {
        setBean(object);
        setInitBean(object)
    }

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            createNewItem();
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "Value", "BudgetIDStr", "IDBudgetSource", "IDBudgetSource"
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length
    };

    useEffect(() => {
        onChange(lista);
    }, [lista])

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={(e) => { setRowBean(e) }} listButtons={listaBotones()} iconButtons={iconButtonsItem} />
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={validateData} >
                    <div className="row">
                        <>
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('BudgetIDStr') ? 'has-error' : ''}`}>Rubro Presupuestal</label>
                                <SelectBudgetID label=" " onChange={(e) => { setBean({ ...bean, "BudgetIDStr": e.JsonCode }) }} jsonCode={bean.BudgetIDStr} edit={false} />
                            </div>
                            {bean.BudgetIDStr &&
                                <div className="col-md-12">
                                    <label className={`${missingFields.includes('BudgetIDStr') ? 'has-error' : ''}`}>Recurso Presupuestal</label>
                                    <SelectBudgetResourceForYear config={{
                                        date: formData.FormDate,
                                        budget: bean.BudgetIDStr,
                                        label: " "
                                    }} idSelector={bean.IDBudgetResource} onChange={(e) => { setBean({ ...bean, "IDBudgetResource": e }) }} />
                                </div>
                            }
                            {bean.IDBudgetResource &&
                                <div className="col-md-12">
                                    <label className={`${missingFields.includes('IDBudgetSource') ? 'has-error' : ''}`}>Fuente Presupuestal</label>
                                    <SelectBudgetSourceForYear label=" " idSelector={bean.IDBudgetSource} onChange={(e) => { setBean({ ...bean, "IDBudgetSource": e }) }} cProps={{
                                        budgetIDSTr: bean.BudgetIDStr,
                                        budgetResource: bean.IDBudgetResource,
                                        date: formData.FormDate,
                                    }} />
                                </div>
                            }
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('Value') ? 'has-error' : ''}`}>Valor de la Apropiación</label>
                                <InputMoney _label=' ' _value={bean.Value} onChange={(e: any) => { setBean({ ...bean, 'Value': e }) }} />
                            </div>
                        </>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="Description" className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }} />
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}